export enum PreparationType {
    FAB = "FAB",
    ASV = "ASV"
}
